export const LOADING = {
  START: 'LOADING_STARTED',
  DONE: 'LOADING_DONE',
  SET_INITIAL: 'LOADING_SET_INITIAL',
};

export const USER = {
  SET_SESSION: 'SET_SESSION',
  SET_USER: 'SET_USER',
  SET_PHONE: 'SET_PHONE',
  SET_BALANCE: 'SET_BALANCE',
  SET_BALANCE_IS_FETCHING: 'SET_BALANCE_IS_FETCHING',
  REMOVE_PHONE: 'REMOVE_PHONE',
  LOGOUT: 'LOGOUT',
  REGISTRATION: 'REGISTRATION',
  BEFORE_REGISTRATION: 'BEFORE_REGISTRATION',
  ERROR: 'ERROR',
  SET_SAVED_SEARCHES: 'SET_SAVED_SEARCHES',
  SET_SHOW_SAVE_SEARCH_BTN: 'SET_SHOW_SAVE_SEARCH_BTN',
};
export const HISTORY = {
  CURRENT_PATH_SET: 'HISTORY_CURRENT_PATH_SET',
  CURRENT_ROUTE_NAME_SET: 'HISTORY_CURRENT_ROUTE_NAME_SET',
  PREVIOUS_ROUTE_NAME_SET: 'HISTORY_PREVIOUS_ROUTE_NAME_SET',
  PREVIOUS_PATH_SET: 'HISTORY_PREVIOUS_PATH_SET',
  NEXT_SEARCH_ITEM_INDEX: 'HISTORY_NEXT_SEARCH_ITEM_INDEX',
};

export const NOTIFICATIONS = {
  ENQUEUE: 'NOTIFICATIONS_ENQUEUE',
  SHIFT: 'NOTIFICATIONS_SHIFT',
};

export const FAVORITES = {
  SET: 'FAVORITES_SET',
  ADD: 'FAVORITES_ADD',
  REMOVE: 'FAVORITES_REMOVE',
  TOGGLE: 'FAVORITES_TOGGLE',
};

export const HOME_SPECIAL_CARS = {
  SET: 'HOME_SPECIAL_CARS_SET',
};

export const HOME_NEWS = {
  SET: 'HOME_NEWS',
};

export const HOME_COUNTERS = {
  SET: 'HOME_COUNTERS',
};

export const ADVERT_TOP_CARS = {
  SET: 'ADVERT_TOP_CARS',
};

export const MOTO_SET_ADVERTS = {
  SET: 'MOTO_SET_ADVERTS',
};

/* ADVERT FORM */

export const ADVERT_FORM = {
  SELECTED: {
    SET__ID: 'SET__ID',
    SET__ACTIVE: 'SET__ACTIVE',
    SET__TRANSPORT: 'SET__TRANSPORT',
    SET__MAKE: 'SET__MAKE',
    SET__MODEL: 'SET__MODEL',
    SET__GENERATION: 'SET__GENERATION',
    SET__YEAR: 'SET__YEAR',
    SET__CURRENCY: 'SET__CURRENCY',
    SET__ENGINE: 'SET__ENGINE',
    SET__DRIVE: 'SET__DRIVE',
    SET__GEARBOX: 'SET__GEARBOX',
    SET__MODIFICATION: 'SET__MODIFICATION',
    SET__EQUIPMENT: 'SET__EQUIPMENT',
    SET__PHOTOS: 'SET__PHOTOS',
    SET__VIDEO: 'SET__VIDEO',
    SET__COLOR: 'SET__COLOR',
    SET__MILEAGE: 'SET__MILEAGE',
    SET__MILEAGE_UNIT: 'SET__MILEAGE_UNIT',
    SET__VIN: 'SET__VIN',
    SET__PRICE: 'SET__PRICE',
    SET__DESCRIPTION: 'SET__DESCRIPTION',
    SET__SERIES: 'SET__SERIES',
    SET__BODY: 'SET__BODY',
    SET__OPTIONS: 'SET__OPTIONS',
    SET__LOCATION: 'SET__LOCATION',
    SET__CONTACT_NAME: 'SET__CONTACT_NAME',
    SET__EMAIL: 'SET__EMAIL',
    SET__PHONES: 'SET__PHONES',
    SET__ABROAD: 'SET__ABROAD',
    SET__DRIVEN_FROM: 'SET__DRIVEN_FROM',
    ADD__PHONE: 'ADD__PHONE',
    REMOVE__PHONE: 'REMOVE__PHONE',
    ADD__PHOTOS: 'ADD__PHOTOS',
    REMOVE__PHOTOS: 'REMOVE__PHOTOS',
    TOGGLE__COLOR_FEATURES: 'TOGGLE__COLOR_FEATURES',
    TOGGLE__STATUSES: 'TOGGLE__STATUSES',
    TOGGLE__ADVERT_FIELDS: 'TOGGLE__ADVERT_FIELDS',
    CLEAR__OPTIONS: 'CLEAR__OPTIONS',
    TOGGLE__CLARIFY_PRICE: 'TOGGLE__CLARIFY_PRICE',
    SET__CLARIFY_PRICE: 'SET__CLARIFY_PRICE',
    SET__CLARIFY_PRICE_LINK: 'SET__CLARIFY_PRICE_LINK',
    SET__CATEGORY: 'SET__CATEGORY',
    SET__ENGINE_ORDER: 'SET__ENGINE_ORDER',
    SET__TACTS: 'SET__TACTS',
    SET__CAPACITY: 'SET__CAPACITY',
    SET__CAPACITY_UNIT: 'SET__CAPACITY_UNIT',
    SET__POWER: 'SET__POWER',
    SET__POWER_UNIT: 'SET__POWER_UNIT',
    SET__CABIN: 'SET__CABIN',
    SET__UNLOADING: 'SET__UNLOADING',
    SET__ECOTYPE: 'SET__ECOTYPE',
    SET__CABIN_SUSPENSION: 'SET__CABIN_SUSPENSION',
    SET__CHASSIS_SUSPENSION: 'SET__CHASSIS_SUSPENSION',
    SET__SEATS: 'SET__SEATS',
    SET__TONNAGE: 'SET__TONNAGE',
    SET__CAPACITY_BODY: 'SET__CAPACITY_BODY',
    SET__AXISES: 'SET__AXISES',
    SET__DIMENSION_WIDTH: 'SET__DIMENSION_WIDTH',
    SET__DIMENSION_HEIGHT: 'SET__DIMENSION_HEIGHT',
    SET__DIMENSION_LENGTH: 'SET__DIMENSION_LENGTH',
    SET__DIMENSION_WEIGHT: 'SET__DIMENSION_WEIGHT',
    SET__CAPACITY_BUCKET: 'SET__CAPACITY_BUCKET',
    SET__LAYING_WIDTH: 'SET__LAYING_WIDTH',
    SET__LIFT_HEIGHT: 'SET__LIFT_HEIGHT',
    SET__ADMISSION_HEIGHT: 'SET__ADMISSION_HEIGHT',
    SET__ARM_BOOM: 'SET__ARM_BOOM',
    SET__DEP_BIG: 'SET__DEP_BIG',
    SET__PRODUCTIVITY: 'SET__PRODUCTIVITY',
    SET__CAPACITY_BODY_TYPE: 'SET__CAPACITY_BODY_TYPE',
    SET__SUSPENSION: 'SET__SUSPENSION',
    SET__BRAKES: 'SET__BRAKES',
    SET__MODEL_TITLE: 'SET__MODEL_TITLE',
    SET__MAKE_TITLE: 'SET__MAKE_TITLE',
    SET__OVERALL_LENGTH: 'SET__OVERALL_LENGTH',
    SET__DRY_WEIGHT: 'SET__DRY_WEIGHT',
    SET__DRAFT: 'SET__DRAFT',
    SET__DISPLACEMENT: 'SET__DISPLACEMENT',
    SET__FUEL_TANK: 'SET__FUEL_TANK',
    SET__WATER_TANK: 'SET__WATER_TANK',
    SET__SEAWORTHINESS_CLASS: 'SET__SEAWORTHINESS_CLASS',
    SET__REG_NUMBER: 'SET__REG_NUMBER',
    SET__USED_WARRANTY: 'SET__USED_WARRANTY',
  },
  // Data
  DATA_MODELS_SET: 'ADVERT_FORM_DATA_MODELS_SET',
  DATA_MODIFICATIONS_SET: 'ADVERT_FORM_DATA_MODIFICATIONS_SET',
  DATA_EQUIPMENTS_SET: 'ADVERT_FORM_DATA_EQUIPMENTS_SET',
  DATA_PRICES_SET: 'ADVERT_FORM_DATA_PRICES_SET',
  DATA_EXISTING_PHOTOS_SET: 'ADVERT_FORM_DATA_EXISTING_PHOTOS_SET',
  DATA_EXISTING_PHOTOS_SET_NEW: 'DATA_EXISTING_PHOTOS_SET_NEW',
  DATA_EXISTING_ADVERTS_SET_NEW: 'DATA_EXISTING_ADVERTS_SET_NEW',
  DATA_NEW_ADVERT: 'DATA_NEW_ADVERT',
  DATA_CURRENT_FORM_STEP: 'DATA_CURRENT_FORM_STEP',
  DATA_YEARS_SET: 'ADVERT_FORM_DATA_YEARS_SET',
  DATA_GENERATIONS_SET: 'ADVERT_FORM_DATA_GENERATIONS_SET',
  DATA_SERIES_SET: 'ADVERT_FORM_DATA_SERIES_SET',
  DATA_DRIVES_SET: 'ADVERT_FORM_DATA_DRIVES_SET',
  DATA_GEARBOXES_SET: 'ADVERT_FORM_DATA_GEARBOXES_SET',
  DATA_AVERAGE_PRICE_SET: 'ADVERT_FORM_DATA_AVERAGE_PRICE_SET',
  DATA_ADVERTS_AVERAGE_PRICE_SET: 'ADVERT_FORM_DATA_ADVERTS_AVERAGE_PRICE_SET',
  DATA_AVERAGE_PRICE_PARAMS_SET: 'ADVERT_FORM_DATA_AVERAGE_PRICE_PARAMS_SET',
  DATA_WARRANTY_SET: 'ADVERT_FORM_DATA_WARRANTY_SET',
  DATA_SHOW_AVERAGE_PRICE_SET: 'ADVERT_FORM_DATA_SHOW_AVERAGE_PRICE_SET',
  // Vocabulary
  VOCABULARY_SET: 'ADVERT_FORM_VOCABULARY_SET',
  VOCABULARY_CLEAR: 'ADVERT_FORM_VOCABULARY_CLEAR',
  // Clear
  CLEAR: 'ADVERT_FORM_CLEAR',
  //
  SET_IS_EDIT: 'ADVERT_FORM_SET_IS_EDIT',
  //
  SET_IS_CLEAR_BTN: 'ADVERT_FORM_SET_IS_CLEAR_BTN',
};

/* SEARCH FORM */

const searchFormSelectedFields = [
  'SET__MAKE',
  'SET__MAKES',
  'SET__MODEL',
  'SET__GENERATION',
  'SET__YEAR_FROM',
  'SET__YEAR_TO',
  'SET__MILEAGE_FROM',
  'SET__COMPANY',
  'SET__TYPE_WORK',
  'SET__MILEAGE_TO',
  'SET__PRICE_FROM',
  'SET__PRICE_TO',
  'SET__MONTHLY',
  'SET__PREPAID',
  'SET__POWER_FROM',
  'SET__POWER_TO',
  'SET__POWER_UNIT',
  'SET__CAPACITY_FROM',
  'SET__CAPACITY_TO',
  'SET__CAPACITY_UNIT',
  'SET__CURRENCY',
  'SET__ENGINE',
  'SET__DRIVE',
  'SET__GEARBOX',
  'SET__MILEAGE_UNIT',
  'SET__CATEGORY',
  'SET__ENGINE_ORDER',
  'SET__TACTS',
  'SET__TRANSPORT_CHILD',
  'SET__SERIES',
  'SET__BODY',
  'SET__OPTIONS',
  'SET__LOCATION',
  'SET__DEALER',
  'SET__FIRM',
  'SET__TRANSPORT',
  'SET__ORDERING',
  'SET__PERIOD',
  'SET__IS_RENT',
  'SET__IS_NEW',
  'SET__HAS_NEW',
  'SET__IS_USED',
  'SET__TAGS',
  'SET__IS_ORIGINAL',
  'SET__IS_ANALOGUE',
  'SET__ABROAD',
  'SET__FROM_DEALER',
  // Avto
  'SET__DRIVEN_FROM',
  'SET__USED_WARRANTY',
  // Truck
  'SET__ECOTYPE',
  'SET__UNLOADING',
  'SET__TONNAGE_FROM',
  'SET__TONNAGE_TO',
  // Bus
  'SET__SEATS',
  // Technics
  'SET__CAPACITY_BODY_FROM',
  'SET__CAPACITY_BODY_TO',
  'SET__CAPACITY_BUCKET_FROM',
  'SET__CAPACITY_BUCKET_TO',
  'SET__LAYING_WIDTH_FROM',
  'SET__LAYING_WIDTH_TO',
  'SET__LIFT_HEIGHT_FROM',
  'SET__LIFT_HEIGHT_TO',
  'SET__ADMISSION_HEIGHT_FROM',
  'SET__ADMISSION_HEIGHT_TO',
  'SET__ARM_BOOM_FROM',
  'SET__ARM_BOOM_TO',
  'SET__DEP_BIG_FROM',
  'SET__DEP_BIG_TO',
  'SET__PRODUCTIVITY_FROM',
  'SET__PRODUCTIVITY_TO',
  //
  'SET__IN_STOCK',
  'SET__IS_UNDER_THE_ORDER',
  'SET__IS_CRASHED',
  'SET__IS_NOT_CLEARED',
  'SET__IS_SWAP',
  'SET__IS_UNDER_LOAN',
  'SET__IS_SALE_ON_CREDIT',
  'SET__COLORS',
  'SET__PHOTOS',
  'SET__FROM_AUCTION',
  'SET__IS_OFFICIAL',
  'SET__Q',
  'SET__QUERY',
  'SET__TEST_DRIVE',
  'SET__TRADE_IN',
  'SET__CREDIT',
  'SET__INSURANCE',
  'SET__ACCESSORIES',
  'SET__RUBRIC',
  'SET__SPARETYPE',
  // 'SET__STATE',
  // 'SET__PRICE',
  // 'SET__DESCRIPTION',
  // 'SET__WHEEL',
  // 'SET__CREDIT',
  // 'SET__CUSTOMS',
  'TOGGLE__COLORS',
  'TOGGLE__COLOR_FEATURES',
  'TOGGLE__STATUSES',
  'TOGGLE__PRICE_STATUSES',
  'CLEAR__OPTIONS',
];

export const SEARCH_FORM = {
  // { SET__MAKE: 'SET__MAKE', ... }
  SELECTED: searchFormSelectedFields.reduce((object, field) => ({ ...object, [field]: field }), {}),
  // Results
  RESULTS_SET: 'SEARCH_FORM_RESULTS_SET',
  COUNTS_SET: 'SEARCH_FORM_COUNTS_SET',
  // Data
  DATA_COUNT_SET: 'SEARCH_FORM_DATA_COUNT_SET',
  DATA_MAKES_COUNTER_SET: 'SEARCH_FORM_DATA_COUNTER_SET',
  DATA_BRAND_TO_CHOSE_SET: 'SEARCH_FORM_DATA_BRAND_TO_CHOSE_SET',
  DATA_MODELS_SET: 'SEARCH_FORM_DATA_MODELS_SET',
  DATA_GENERATIONS_SET: 'SEARCH_FORM_DATA_GENERATIONS_SET',
  DATA_SPARETYPES_SET: 'DATA_SPARETYPES_SET',

  // to remove
  DATA_MODIFICATIONS_SET: 'SEARCH_FORM_DATA_MODIFICATIONS_SET',
  DATA_EQUIPMENTS_SET: 'SEARCH_FORM_DATA_EQUIPMENTS_SET',
  DATA_PRICES_SET: 'SEARCH_FORM_DATA_PRICES_SET',
  DATA_YEARS_SET: 'SEARCH_FORM_DATA_YEARS_SET',
  DATA_SERIES_SET: 'SEARCH_FORM_DATA_SERIES_SET',

  // Vocabulary
  VOCABULARY_SET: 'SEARCH_FORM_VOCABULARY_SET',

  // Clear
  CLEAR: 'SEARCH_FORM_CLEAR',
  RESET_ALL: 'SEARCH_FORM_RESET_ALL',
};

export const GLOBALS = {
  PROMOTE_IN_SOCIAL_SET: 'GLOBALS_PROMOTE_IN_SOCIAL_SET',
  LOCATION_SET: 'GLOBALS_LOCATION_SET',
  FINGERPRINT_SET: 'GLOBALS_FINGERPRINT_SET',
  SET_REDIRECT_URL: 'GLOBALS_SET_REDIRECT_URL',
  RATIO_SET: 'GLOBALS_RATIO_SET',
  TARGETING_ARGUMENTS_SET: 'TARGETING_ARGUMENTS_SET',
  SEO_SEARCH_URLS: 'SEO_SEARCH_URLS',
  PAYMENT_SET_MODAL: 'PAYMENT_SET_MODAL',
  DATA_LAYER_SET: 'DATA_LAYER_SET',
  BANNER_SHOW: 'BANNER_SHOW',
  BANNER_UPDATE: 'BANNER_UPDATE',
  BANNER_HIDE: 'BANNER_HIDE',
  SEO_TEXT_SET: 'GLOBALS_SEO_TEXT_SET',
  DEALER_SLUG_SET: 'GLOBALS_DEALER_SLUG_SET',
  // insurance start
  SET_INSURANCE_ORDERS: 'SET_INSURANCE_ORDERS',
  SET_INSURANCE_REGIONS: 'SET_INSURANCE_REGIONS',
  SET_INSURANCE_FILTERS: 'SET_INSURANCE_FILTERS',
  SET_INSURANCE_MAKES: 'SET_INSURANCE_MAKES',
  SET_SELECTED_VALUES: 'SET_SELECTED_VALUES',
  SET_SELECTED_OFFER: 'SET_SELECTED_OFFER',
  SET_ORDER_WITH_HASH: 'SET_ORDER_WITH_HASH',
  SET_FILL_DATA: 'SET_FILL_DATA',
  SET_OFFERS_DATA: 'SET_OFFERS_DATA',
  SET_IS_NUMBER_BLOCK: 'SET_IS_NUMBER_BLOCK',
  SET_ORDER_FOR_EDIT: 'SET_ORDER_FOR_EDIT',
  SET_SHOW_CONFIRM_MODAL: 'SET_SHOW_CONFIRM_MODAL',
  // insurance end
  SET_IS_APPROVE_PUB: 'SET_IS_APPROVE_PUB',
};

export const JOURNAL = {
  SET_NEWS: 'SET_NEWS',
  SET_VIDEO_TOPICS: 'SET_VIDEO_TOPICS',
  SET_VIDEO_FILTERS: 'SET_VIDEO_FILTERS',
  SET_SELECTED_VIDEO_PARAMS: 'SET_SELECTED_VIDEO_PARAMS',
  SET_SELECTED_VIDEO_DATA: 'SET_SELECTED_VIDEO_DATA',
  SET_VIDEO_HEAD_FILTER: 'SET_VIDEO_HEAD_FILTER',
};



// WEBPACK FOOTER //
// ./src/shared/constants/actionTypes.js